import React from "react";
import ErrorShell, { GoHomeButton } from "./ErrorShell";
export default function Unauthorized() {
  return <ErrorShell code="403" title="Access denied" message="You don't have permission to view this page. Contact your administrator if you think this is a mistake." action={<GoHomeButton label="Back to login" />} />;
}
